/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

"use strict";var Ajaxinate=function(t){var e=t||{};this.settings=Object.assign({pagination:"#AjaxinatePagination",method:"scroll",container:"#AjaxinateLoop",offset:0,loadingText:"Loading",callback:null},e),this.addScrollListeners=this.addScrollListeners.bind(this),this.addClickListener=this.addClickListener.bind(this),this.checkIfPaginationInView=this.checkIfPaginationInView.bind(this),this.stopMultipleClicks=this.stopMultipleClicks.bind(this),this.destroy=this.destroy.bind(this),this.containerElement=document.querySelector(this.settings.container),this.paginationElement=document.querySelector(this.settings.pagination),this.initialize()};Ajaxinate.prototype.initialize=function(){this.containerElement&&{click:this.addClickListener,scroll:this.addScrollListeners}[this.settings.method]()},Ajaxinate.prototype.addScrollListeners=function(){this.paginationElement&&(document.addEventListener("scroll",this.checkIfPaginationInView),window.addEventListener("resize",this.checkIfPaginationInView),window.addEventListener("orientationchange",this.checkIfPaginationInView))},Ajaxinate.prototype.addClickListener=function(){this.paginationElement&&(this.nextPageLinkElement=this.paginationElement.querySelector("a"),this.clickActive=!0,null!==this.nextPageLinkElement&&this.nextPageLinkElement.addEventListener("click",this.stopMultipleClicks))},Ajaxinate.prototype.stopMultipleClicks=function(t){t.preventDefault(),this.clickActive&&(this.nextPageLinkElement.innerHTML=this.settings.loadingText,this.nextPageUrl=this.nextPageLinkElement.href,this.clickActive=!1,this.loadMore())},Ajaxinate.prototype.checkIfPaginationInView=function(){var t=this.paginationElement.getBoundingClientRect().top-this.settings.offset,e=this.paginationElement.getBoundingClientRect().bottom+this.settings.offset;t<=window.innerHeight&&e>=0&&(this.nextPageLinkElement=this.paginationElement.querySelector("a"),this.removeScrollListener(),this.nextPageLinkElement&&(this.nextPageLinkElement.innerHTML=this.settings.loadingText,this.nextPageUrl=this.nextPageLinkElement.href,this.loadMore()))},Ajaxinate.prototype.loadMore=function(){this.request=new XMLHttpRequest,this.request.onreadystatechange=function(){if(4===this.request.readyState&&200===this.request.status){var t=this.request.responseXML.querySelectorAll(this.settings.container)[0],e=this.request.responseXML.querySelectorAll(this.settings.pagination)[0];this.containerElement.insertAdjacentHTML("beforeend",t.innerHTML),this.paginationElement.innerHTML=e.innerHTML,this.settings.callback&&"function"==typeof this.settings.callback&&this.settings.callback(this.request.responseXML),this.initialize()}}.bind(this),this.request.open("GET",this.nextPageUrl),this.request.responseType="document",this.request.send()},Ajaxinate.prototype.removeClickListener=function(){this.nextPageLinkElement.addEventListener("click",this.stopMultipleClicks)},Ajaxinate.prototype.removeScrollListener=function(){document.removeEventListener("scroll",this.checkIfPaginationInView),window.removeEventListener("resize",this.checkIfPaginationInView),window.removeEventListener("orientationchange",this.checkIfPaginationInView)},Ajaxinate.prototype.destroy=function(){return{click:this.removeClickListener,scroll:this.removeScrollListener}[this.settings.method](),this};

function CreateRedirectHelper(contentStartSelector, contentEndSelector, containerSelector, rebuildPage) {
  const _this = this;
  this.containerSelector = containerSelector;
  this.contentStartSelector = contentStartSelector;
  this.contentEndSelector = contentEndSelector;
  this.rebuildPage = rebuildPage;
  this.pagesState = [];
  this.pageContentUpdating = false;
  this.setPageContentUpdating = function (pageContentUpdating) {
      _this.pageContentUpdating = pageContentUpdating;
  };
  this.initPageLoad = function (url, redirectAfterLoad) {
      if (_this.pagesState.find(pageState => pageState.url === url) && !redirectAfterLoad) {
          return;
      }
      if (window.location.pathname === url) {
          return;
      }
      _this.pagesState.push({
          url: url,
          content: "",
          pageTitle: "",
          loaded: false,
          redirectOnLoad: false
      });
      _this.getPage(url, redirectAfterLoad);
  };
  this.getPage = function (url, redirectAfterLoad) {
      fetch(url).then(async (res) => {
          let response = await res.text();
          return ({
              content: response.substring(response.indexOf(_this.contentStartSelector) + _this.contentStartSelector.length, response.indexOf(_this.contentEndSelector)),
              title: response.substring(response.indexOf('<title>') + 7, response.indexOf("</title>"))
          })
      }).then(requiredPage => {
          const page = _this.pagesState.find(pageState => pageState.url === url);
          page.content = requiredPage.content;
          page.title = requiredPage.title;
          page.loaded = true;
          if (page.redirectOnLoad || redirectAfterLoad) {
              _this.loadPage(url);
          }
      });
  };
  this.loadPage = function (url) {
      if (url === window.location.pathname) {
          return;
      }
      _this.setPageContentUpdating(true);
      const requiredPage = _this.pagesState.find(pageState => pageState.url === url);
      if (requiredPage && requiredPage.loaded) {
          document.querySelector(_this.containerSelector).innerHTML = requiredPage.content;
          document.title = requiredPage.title;
          window.history.pushState({
              htmlForMain: requiredPage.content,
              pageTitle: requiredPage.title
          }, "", requiredPage.url);
          _this.setPageContentUpdating(false);
      } else if (requiredPage && !requiredPage.loaded) {
          requiredPage.redirectOnLoad = true;
      } else {
          _this.getPage(url, true);
      }
      setTimeout(function () {
          _this.rebuildPage();
      }, 100);
  };
  return {
      pageContentUpdating: _this.pageContentUpdating,
      pagesState: _this.pagesState,
      setPageContentUpdating: _this.setPageContentUpdating,
      initPageLoad: _this.initPageLoad,
      getPage: _this.getPage,
      loadPage: _this.loadPage
  };
}
function rebindEventListeners() {
  // function to run after the HTML has been exchanged

  document.querySelectorAll('[data-product-url]').forEach(link => {
    link.addEventListener('mouseover', function (e) {
        const link = this.getAttribute('data-product-url');
        window.productRefresher.initPageLoad(link);
    });
      link.addEventListener('click', function(e) {
          const link = this.getAttribute('data-product-url');
          if(!window.productRefresher.pageContentUpdating) {
              document.querySelector('.Product ').classList.add('loading');
              window.productRefresher.loadPage(link);
          }
        });
      });

      new window.product(document.querySelector('section.Product.Product--medium'))
}
function initProductRefresher() {
  window.productRefresher = new CreateRedirectHelper('<!-- START_PRODUCT_TEMPLATE -->', "<!-- END_PRODUCT_TEMPLATE -->", '#product--container', rebindEventListeners);
  document.querySelectorAll('[data-product-url]').forEach(link => {
      link.addEventListener('mouseover', function (e) {
          const link = this.getAttribute('data-product-url');
          window.productRefresher.initPageLoad(link);
      });
      link.addEventListener('click', function(e) {
          const link = this.getAttribute('data-product-url');
          if(!window.productRefresher.pageContentUpdating) {
              document.querySelector('.Product ').classList.add('loading');
              window.productRefresher.loadPage(link);
          }
      });
  });
}
initProductRefresher();

document.addEventListener('keydown', function(e) {
    if (e.target.classList.contains('Search__Input') && e.key === 'Enter') {
        const submitBtn = document.querySelector('.Search__InputIconWrapper button[type="submit"]');
        submitBtn.click();
    }
});

document.addEventListener('click', function(e) {
    if (e.target.getAttribute('data-action') === 'drawer-add-to-cart') {
        e.preventDefault();

        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                items: [
                    {
                      quantity: e.target.getAttribute('data-quantity'),
                      id: e.target.getAttribute('data-id')
                    }
                ]
            })
        }).then(res => res.json()).then(() => {
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh'));
        });
    }
});

document.addEventListener('DOMContentLoaded', function() {
    const wrapper = document.querySelector('.ProductList');
    const url = window.location.href;

    if (url.includes('customer_posted=true')) {
        document.addEventListener('galleryReady:covetPics', function(e) {
            const newsLetterForm = document.querySelector('#shopify-section-newsletter');
            const y = newsLetterForm.getBoundingClientRect().top + window.pageYOffset - 110;
            if (newsLetterForm) {
              window.scrollTo({top: y, behavior: "smooth"});
            }
        });    
    }

    if (wrapper) {
        const productCount = wrapper.getAttribute('data-product-count');
        const loader = document.querySelector('.Pagination .Image__Loader');

        if (productCount <= 20 && loader) {
            loader.remove();
        }

        new Ajaxinate({
            container: '.ProductList',
            pagination: '.Pagination__Nav',
            loadingText: 'Pagination',
            offset: -100,
            callback () {
                setTimeout(() => {
                    if (wrapper) {
                        const itemCount = wrapper.querySelectorAll('.Grid__Cell').length;
                        if (productCount == itemCount && loader) {
                            loader.remove();
                        }
                    }
                }, 100);
            }
        });
    };

    window.onload = () => {
        if (url.includes('challenge')) {
            const challengeForm = document.querySelector('.shopify-challenge__container form')

            challengeForm.action += window.location.hash 
            
            setTimeout(() => {
                window.scrollTo({
                    top: 0,
                    left: 0,
                    behavior: 'smooth'
                });
            }, 200);
        }
    }
});

/**
 * Save selected language in local storage
 */

var localeButtons = document.querySelectorAll('button[name="locale_code"]')

if (localeButtons.length > 0) {
    for (var i = 0; i < localeButtons.length; i++) {
        localeButtons[i].addEventListener('click', function(event) {
            const button = this;

            if (button.classList.contains('js-clicked')) {
                return false
            }

            event.preventDefault();
            var selectedLocale = button.value;

            localStorage.setItem('CRISP.selectedLocale', selectedLocale);
            button.classList.add('js-clicked');
            button.click();
        })
    }
}

var locationPopup = document.querySelector('.location-popup');

if (locationPopup) {
    var locationData = JSON.parse(localStorage.getItem('CRISP.location'));
    var selectedLocale = localStorage.getItem('CRISP.selectedLocale');
    var locationPopupClosed = localStorage.getItem('CRISP.locationPopupClosed')
    var locationPopupDelay = Number(locationPopup.dataset.delay) * 1000

    if (selectedLocale && Shopify.locale !== selectedLocale) {
        var newLocale = selectedLocale === 'en' ? '' : selectedLocale
        window.location.pathname = '/' + newLocale
    }

    if (!locationData) {
        var user = {
            isInEU: null,
            locale: null,
        }

        var store = {
            isInEU: Shopify.country === 'US' ? false : true,
            locale: Shopify.locale,
            publishedLocales: Shopify.publishedLocales
        }

        getLocation().then(response => {
            user.isInEU = response.result.isInEuropeanUnion;
            user.locale = response.result.code.toLowerCase()

            locationData = {
                store: store,
                user: user
            }

            localStorage.setItem('CRISP.location', JSON.stringify(locationData))

            handleLocation(locationData)
        })
    } else {
        handleLocation(locationData)
    }

    locationPopup.querySelector('.js-decline-redirect').addEventListener('click', function() {
        localStorage.setItem('CRISP.locationPopupClosed', 'true')
        locationPopup.ariaHidden = true;
    })

    function handleLocation (data) {
        if (data.user.isInEU && data.store.isInEU) {
            if (!selectedLocale && data.user.locale !== data.store.locale) {
                if (data.store.publishedLocales.includes(data.user.locale)) {
                    localStorage.setItem('CRISP.selectedLocale', data.user.locale);
                    window.location.pathname = '/' + data.user.locale
                } else {
                    localStorage.setItem('CRISP.selectedLocale', 'en')

                    if (data.store.locale !== 'en') {
                        window.location.pathname = '/'
                    }
                }
            }
        } else if ((data.user.isInEU && !data.store.isInEU) || (!data.user.isInEU && data.store.isInEU)) {
            // If either user or store not in Europe - show popup
            if (!locationPopupClosed) {
                setTimeout(() => {
                    locationPopup.ariaHidden = false;
                }, locationPopupDelay);
            }
        }
    }
}

function getLocation () {
    return fetch('https://geoip.crispstudio.cloud/', {
        method: 'get'
    }).then(response => {
        if (response.ok) {
            return response.json()
        }

        return Promise.reject(Error('error'))
    }).catch(error => {
        return Promise.reject(Error(error.message))
    })
}

document.addEventListener('click', function(event) {
	var increaseQtyButtons = document.querySelectorAll('.js-increase-qty');

	increaseQtyButtons.forEach(function(element, index){
		if (event.target === element || event.target.closest('.js-increase-qty') === element) {
			event.preventDefault();
			var qtyInput = element.previousElementSibling
			var step = 1
	
			if (qtyInput.dataset.step) {
					step = Number(qtyInput.dataset.step)
			}
	
			qtyInput.value = parseInt(qtyInput.value) + step;
		}
	})

	var decreaseQtyButtons = document.querySelectorAll('.js-decrease-qty');

	decreaseQtyButtons.forEach(function(element, index){
		if (event.target === element || event.target.closest('.js-decrease-qty') === element) {
			event.preventDefault();
			var qtyInput = element.nextElementSibling
			var step = 1

			if (qtyInput.dataset.step) {
					step = Number(qtyInput.dataset.step)
			}

			qtyInput.value = Math.max(parseInt(qtyInput.value) - step, step);
		}
	})

	var addToCartButtons = document.querySelectorAll('.js-add-to-cart')

	addToCartButtons.forEach(function(element, index) {
		if (event.target === element || event.target.closest('.js-add-to-cart') === element) {
			event.preventDefault();
			console.log('click')
	
			var form = element.closest('.ProductItem__Form');
			var variantID = form.querySelector('[name="id"]').value
			var quantity = Number(form.querySelector('[name="quantity"]').value)
	
			fetch(window.routes.cartAddUrl + '.js', {
				body: JSON.stringify({
						id: variantID,
						quantity: quantity
				}),
				credentials: 'same-origin',
				method: 'POST',
				headers: {
						'Content-Type': 'application/json',
						'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
				}
			}).then(function (response) {
				document.dispatchEvent(new CustomEvent('theme:loading:end'));
				if (response.ok) {
					element.removeAttribute('disabled');
					// We simply trigger an event so the mini-cart can re-render
					form.dispatchEvent(new CustomEvent('product:added', {
						bubbles: true,
						detail: {
								variant: variantID,
								quantity: quantity
						}
					}));
				} else {
					response.json().then(function (content) {
						var errorMessageElement = document.createElement('span');
						errorMessageElement.className = 'ProductItem__Form-Error Alert Alert--error';
						errorMessageElement.innerHTML = content['description'];
						element.removeAttribute('disabled');
						element.insertAdjacentElement('afterend', errorMessageElement);
						setTimeout(function () {
								errorMessageElement.remove();
						}, 2500);
					});
				}
			});
		}
	})
})

const shippingNotice = document.querySelector('.Cart__ShippingNotice')

if (shippingNotice) {
    const countriesIgnored = [ 'Czechia', 'Denmark', 'Estonia', 'Hungary', 'Latvia', 'Lithuania', 'Poland', 'Slovakia', 'Slovenia', 'Sweden', 'Switzerland', 'United Kingdom', 'Ireland', 'Bulgaria', 'Croatia', 'Cyprus', 'Finland', 'Greece', 'Iceland', 'Norway', 'Romania', 'Spain (Balears Province)' ]
    
    getLocation().then(response => {
        const userCountry = response.result.name

        if (countriesIgnored.indexOf(userCountry) !== -1) {
            console.log(shippingNotice)
            shippingNotice.classList.add('hidden')
        }
    })
}
